import { Component } from 'react'
import { Period, Coding, Hospitalization, CodeableConcepts } from '../helpers'
import { LuFolderCheck, LuFolderX } from 'react-icons/lu'
import { FaPeopleRoof, FaCalendarDays, FaBookMedical } from 'react-icons/fa6'
import { BsHospital } from 'react-icons/bs'


import './resource.css'

class Encounter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div style={{ width: '172px' }}>
            <div className={`Flip-Container`} onClick={() => this.handleJson()}><div style={{ borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px', borderBottom: 'none' }} className={`Res-Container Res-Encounter${this.state.css ? ' Flip' : ''}`}>
                {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                    <div>
                        <div className='Res-Row Res-Flex-Spread'>
                            <div style={{ marginRight: '5px' }}>
                                <div className={`Res-Icon ${this.props.resource.active ? 'Res-Icon-Active' : 'Res-Icon-Inactive'}`}>{this.props.resource.active ? <LuFolderCheck /> : <LuFolderX />}</div>
                                <div className='Res-Icon-Label'>{this.props.resource.active ? 'Active' : "Inactive"}</div>
                            </div>
                            <div className='Res-Icon-Big'><FaPeopleRoof /></div>
                            {this.props.resource.class && <div><div className='Res-Detail'>{Coding(this.props.resource.class)}</div><div className='Res-Icon-Label'>Class</div></div>}
                        </div>
                        {this.props.resource.type && <div className='Res-Row Res-Detail'>{CodeableConcepts(this.props.resource.type)}</div>}
                        {this.props.resource.period && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><FaCalendarDays /></div><div className='Res-Detail'>{Period(this.props.resource.period)}</div></div>}
                        {this.props.resource.reasonCode && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><FaBookMedical /></div><div className='Res-Detail'>{CodeableConcepts(this.props.resource.reasonCode)}</div></div>}
                        {this.props.resource.hospitalization && <div className='Res-Row Res-Flex'><div style={{ marginRight: '5px' }} className='Res-Icon'><BsHospital /></div><div className='Res-Detail'>{Hospitalization(this.props.resource.hospitalization)}</div></div>}
                    </div>
                }
            </div>
            </div>
            <div style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }} className='Encounter-Button' onClick={() => this.handleSelect(this.props.resource.id)}>View Details</div>
        </div>
    }
}

export default Encounter